import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import BookingSuccess from "@/pages/BookingSuccess";
import OfferView from "@/pages/OfferView";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import QRBooking from "@/pages/QRBooking";
import ProductPage from "@/pages/ProductPage";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminBookings from "@/pages/admin/Bookings";
import AdminContacts from "@/pages/admin/Contacts";
import ContactDetail from "@/pages/admin/ContactDetail";
import AdminPipeline from "@/pages/admin/Pipeline";
import AdminOffers from "@/pages/admin/Offers";
import AdminCalendar from "@/pages/admin/Calendar";
import AdminSettings from "@/pages/admin/Settings";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="flex items-center justify-center h-screen"><div className="animate-pulse text-neutral-400">Laddar...</div></div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/biro-small" element={<ProductPage model="small" />} />
                    <Route path="/biro-big" element={<ProductPage model="big" />} />
                    <Route path="/booking/success" element={<BookingSuccess />} />
                    <Route path="/offers/:id" element={<OfferView />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/qr" element={<QRBooking />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                        <Route index element={<Navigate to="/admin/dashboard" replace />} />
                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route path="bookings" element={<AdminBookings />} />
                        <Route path="contacts" element={<AdminContacts />} />
                        <Route path="contacts/:id" element={<ContactDetail />} />
                        <Route path="pipeline" element={<AdminPipeline />} />
                        <Route path="offers" element={<AdminOffers />} />
                        <Route path="calendar" element={<AdminCalendar />} />
                        <Route path="settings" element={<AdminSettings />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster />
        </AuthProvider>
    );
}

export default App;
